import {downloadCSVFiles, getDateWithTimeString} from '@/helpers/shadcn/utils';
import {getSasToken} from '@/services/sasToken';
import {logger} from '@/helpers/logger';

/**
 * Downloads a CSV from an Azure blob URL via SAS token.
 * Mirrors Sales Target review Target Template download (getSasToken →
 * downloadFileOnBlob → downloadCSVFiles).
 *
 * @param {object} options
 * @param {string} options.fileUrl - Full blob URL (must contain `/input`)
 * @param {string} options.templateType - SAS template type (e.g. Constants.PerfectStore)
 * @param {Function} options.downloadFileOnBlob - from useAzureBlob()
 * @param {string} [options.outputFileName] - defaults to Target_Template + timestamp
 */
export const downloadCsvFromBlobUrl = async ({
  fileUrl,
  templateType,
  downloadFileOnBlob,
  outputFileName
}) => {
  try {
    if (!fileUrl || !downloadFileOnBlob) return;

    const blobFileName = fileUrl.split('/').pop();
    const directory = fileUrl.split('/input')[1];

    const sasResponse = await getSasToken(blobFileName, templateType);
    const response = await downloadFileOnBlob(
      sasResponse,
      directory,
      blobFileName
    );

    if (!response?.responseText) {
      throw new Error('No response received from download');
    }

    const fileNameTemp =
      outputFileName || `Target_Template${getDateWithTimeString()}`;
    downloadCSVFiles(response.responseText, fileNameTemp);
  } catch (error) {
    logger.error('Error downloading CSV from blob:', error);
  }
};
